module.exports = __webpack_public_path__ + "static/media/foto_dashboard.7a592b3e.jpg";